import { render, staticRenderFns } from "./usekliveregion.vue?vue&type=template&id=684ee90c"
import script from "./usekliveregion.vue?vue&type=script&lang=js"
export * from "./usekliveregion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports